import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

import { getAuthConfig } from '../utils/auth';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    
    const checkAuth = async () => {
      if (location.state?.user) {
        setIsAuthenticated(true);
        return;
      }

      const token = localStorage.getItem('bluecrate_session_token');
      if (!token) {
        setIsAuthenticated(false);
        return;
      }

      try {
        await axios.get(`${BACKEND_URL}/api/auth/me`, getAuthConfig());
        if (isMountedRef.current) setIsAuthenticated(true);
      } catch {
        if (isMountedRef.current) {
          setIsAuthenticated(false);
          localStorage.removeItem('bluecrate_session_token');
          localStorage.removeItem('bluecrate_user');
        }
      }
    };

    checkAuth();

    return () => {
      isMountedRef.current = false;
    };
  }, [navigate, location.state]);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? children : null;
}

export default ProtectedRoute;
